import { IconProps, IconWeight } from '@phosphor-icons/react';
import { Ref } from 'react';

import { Spacer } from 'theSource/components/Spacer';
import {
  CircularProgressStyled,
  LOADER_SIZE,
  PrimaryIconButtonStyled,
  SecondaryIconButtonStyled,
  TertiaryIconButtonStyled,
} from './IconButtonStyled';

export type IconButtonVariant = 'primary' | 'secondary' | 'tertiary';

export interface IconButtonProps {
  disabled?: boolean;
  Icon: React.ForwardRefExoticComponent<
    IconProps & React.RefAttributes<SVGSVGElement>
  >;
  size?: number;
  isLoading?: boolean;
  onClick: () => void;
  testId?: string;
  variant: IconButtonVariant;
  elementRef?: Ref<HTMLButtonElement>;
  fullWidth?: boolean;
  weight?: IconWeight;
}

export const IconButton = ({
  disabled,
  Icon,
  isLoading,
  size = 2.4,
  variant,
  testId = 'icon-button',
  elementRef,
  fullWidth = false,
  weight = 'regular',
  ...props
}: IconButtonProps) => {
  const IconVariant = (() => {
    switch (variant) {
      case 'primary':
        return PrimaryIconButtonStyled;
      case 'secondary':
        return SecondaryIconButtonStyled;
      case 'tertiary':
        return TertiaryIconButtonStyled;
    }
  })();

  return (
    <IconVariant
      disabled={disabled || isLoading}
      data-testid={testId}
      disableFocusRipple
      $size={size}
      ref={elementRef}
      $fullWidth={fullWidth}
      {...props}
    >
      {isLoading && (
        <>
          <CircularProgressStyled size={`${LOADER_SIZE}rem`} thickness={6} />
          <Spacer width={1} />
        </>
      )}
      <Icon data-testid="icon" size={`${size}rem`} weight={weight} />
    </IconVariant>
  );
};
